import {
  anIdefenseConfig,
  aTaxiiFeed,
  aThreatIntelItemPage,
  aThreatIntelSource,
  aThreatQConfig,
  mockThreatIntelSourceDetailOperationQuery,
  ThreatIntelSourceType,
} from '__generated__';

export const getCustomThreatIntelSourceDetailOperationQuery = ({
  name,
  description,
  intelItemsCount = 0,
}) => {
  return mockThreatIntelSourceDetailOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(500), // mock loading state
      ctx.data({
        __typename: 'Query',
        threatIntelSource: aThreatIntelSource({
          description: description,
          id: '1',
          items: aThreatIntelItemPage({
            total: intelItemsCount,
          }),
          name: name,
          sourceType: ThreatIntelSourceType.Custom,
        }),
      })
    );
  });
};

export const getTaxiiThreatIntelSourceDetailOperationQuery = ({
  name,
  description,
  intelItemsCount = 0,
}) => {
  return mockThreatIntelSourceDetailOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        threatIntelSource: aThreatIntelSource({
          description: description,
          id: '1',
          items: aThreatIntelItemPage({
            total: intelItemsCount,
          }),
          name: name,
          sourceType: ThreatIntelSourceType.Taxii,
          taxiiFeed: aTaxiiFeed({
            maxLookbackDays: 7,
            url: 'http://besttaxii.com/taxii-discovery-service',
          }),
        }),
      })
    );
  });
};

export const getIdefenseThreatIntelSourceDetailOperationQuery = ({
  name,
  description,
  apiKey,
  intelItemsCount = 0,
}) => {
  return mockThreatIntelSourceDetailOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        threatIntelSource: aThreatIntelSource({
          description: description,
          id: '1',
          items: aThreatIntelItemPage({
            total: intelItemsCount,
          }),
          name: name,
          sourceType: ThreatIntelSourceType.Idefense,
          idefenseConfig: anIdefenseConfig({
            apiKey,
            enabled: true,
          }),
        }),
      })
    );
  });
};

export const getThreatQThreatIntelSourceDetailOperationQuery = ({
  name,
  description,
  baseUrl,
  clientId,
  pollInterval,
  intelItemsCount = 0,
}) => {
  return mockThreatIntelSourceDetailOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        threatIntelSource: aThreatIntelSource({
          description: description,
          id: '1',
          items: aThreatIntelItemPage({
            total: intelItemsCount,
          }),
          name: name,
          sourceType: ThreatIntelSourceType.Threatq,
          threatQConfig: aThreatQConfig({
            baseUrl,
            clientId,
            pollIntervalMinutes: pollInterval,
            customFiltersJson: '[]',
          }),
        }),
      })
    );
  });
};

export const handlers = [
  mockThreatIntelSourceDetailOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        threatIntelSource: aThreatIntelSource(),
      })
    );
  }),
];
